import React from 'react';
import ModalContentBase from '../redux/components/modal/modal_content_base';

const SectionIsGenderManaged = ({
  circle,
  event,
  setEvent,
  isNew,
}) => {

  const previewContent = (
    <span>
      <img src="/img/question.png" className="" height="auto" style={{ width: "15px" }} />
    </span>
  );

  const modalContent = (
    <div>
      <div className="modal-view-header">
        <p style={{ margin: "0 0 6px", padding: "1.5em", textAlign: "left" }}>
          <strong>
            <p>
              男女比調整とは
            </p>
          </strong>
        </p>
      </div>
      <div
        className="modal-view-body"
        style={{ padding: "0px 25px 50px", textAlign: "left" }}
      >
        <p className="pb-3">男女の参加人数を調整しているイベントです。</p>
        <p className="pb-3">同性の割合が約3割以上になるように調整されます。</p>
        <p className="pb-3">そのためイベント参加者のうち、男性か女性が１人だけになったり、どちらかに人数が偏りすぎることがないため安心です。</p>
        <p className="pb-3">性別を登録していないユーザーや、タイミングによって条件に合致しないユーザーは参加することができません。</p>
        <p className="pb-3">この機能はプレミアムサークルのみが設定可能です。</p>
      </div>
      <div className="modal-view-footer" />
    </div>
  );

  if (isNew && circle.is_premium_valid && event.min_num_of_people > 3) {
    return (
      <section id="gender_managed">
        <div className="container col-md-8 col-lg-6">
          <div style={{ display: "flex" }}>
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
              男女比調整
            </p>
            <div className="ml-1 mt-3-5">
              <ModalContentBase
                previewContent={previewContent}
                modalContent={modalContent}
              />
            </div>
          </div>
          <p className="text-gray text-fz-small mt-0 mb-1">
            ※最少催行人数が４人以上の場合オンにできます。イベント初回作成時のみ設定できます。あとから変更できません。
          </p>
        </div>
        <div className="shadow-sm mb-3 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="custom-control custom-switch custom-switch-md">
              <input
                type="checkbox"
                className="custom-control-input"
                id="is_gender_managed"
                defaultChecked={event.is_gender_managed}
                onChange={(e) =>
                  setEvent((prev) => ({
                    ...prev,
                    is_gender_managed: e.target.checked,
                  }))
                }
              />
              <label
                className="custom-control-label"
                htmlFor="is_gender_managed"
              >
                男女比を調整する
              </label>
            </div>
          </div>
        </div>
      </section>
    );
  } else if (!isNew) {
    return (
      <section id="gender_managed">
        <div className="container col-md-8 col-lg-6">
          <div style={{ display: "flex" }}>
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
              男女比調整
            </p>
            <div className="ml-1 mt-3-5">
              <ModalContentBase
                previewContent={previewContent}
                modalContent={modalContent}
              />
            </div>
          </div>
          <p className="text-gray text-fz-small mt-0 mb-0">
            ※イベント初回作成時のみ設定できます。あとから変更できません。
          </p>
        </div>
        <div className="shadow-sm mb-3 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="custom-control custom-switch custom-switch-md">
              <input
                type="checkbox"
                className="custom-control-input"
                id="is_gender_managed"
                checked={event.is_gender_managed}
                disabled={!isNew}
              />
              <label
                className="custom-control-label"
                htmlFor="is_gender_managed"
              >
                男女比を調整する
              </label>
            </div>
          </div>
        </div>
      </section>
    );
  } else if (event.min_num_of_people <= 3) {
    return (
      <section id="gender_managed">
        <div className="container col-md-8 col-lg-6">
          <div style={{ display: "flex" }}>
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
              男女比調整
            </p>
            <div className="ml-1 mt-3-5">
              <ModalContentBase
                previewContent={previewContent}
                modalContent={modalContent}
              />
            </div>
          </div>
          <p className="text-gray text-fz-small mt-0 mb-1">
            最少催行人数が４人以上の場合オンにできます。
          </p>
        </div>
        <div className="shadow-sm mb-3 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="custom-control custom-switch custom-switch-md">
              <input
                type="checkbox"
                className="custom-control-input"
                id="is_gender_managed"
                disabled={event.min_num_of_people <= 3}
              />
              <label
                className="custom-control-label"
                htmlFor="is_gender_managed"
              >
                男女比を調整する
              </label>
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <section id="gender_managed">
        <div className="container col-md-8 col-lg-6">
          <div style={{ display: "flex" }}>
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
              男女比調整
            </p>
            <div className="ml-1 mt-3-5">
              <ModalContentBase
                previewContent={previewContent}
                modalContent={modalContent}
              />
            </div>
          </div>
          <p className="text-gray text-fz-small mt-0 mb-0">
            この機能はプレミアムサークルのみが設定可能です。
          </p>
        </div>
        <div className="shadow-sm mb-3 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="custom-control custom-switch custom-switch-md">
              <input
                type="checkbox"
                className="custom-control-input"
                id="is_gender_managed"
                disabled={!circle.is_premium_valid}
              />
              <label
                className="custom-control-label"
                htmlFor="is_gender_managed"
              >
                男女比を調整する
              </label>
            </div>
          </div>
        </div>
      </section>
    );

  }
};

export default SectionIsGenderManaged;
